import React from 'react';
import { withStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import WaveTextArea from '@common/components/form/WaveTextArea';
import { notifyModalStyles } from './styles';
import { DefaultModal } from '@common/components/default-modal';
import { DefaultButton } from '@common/components/default-button';

class NotifyAttendeesModal extends React.Component {
  state = {
    message: ''
  };

  handleMessageChange = event => {
    this.setState({ message: event.target.value });
  };

  handleSubmit = () => {
    const { onSubmit } = this.props;
    const { message } = this.state;

    onSubmit(message);
  };

  render() {
    const { classes, isOpened, onClose, isLoading } = this.props;

    return (
      <DefaultModal
        title="Notify Attendees"
        onClose={onClose}
        isOpened={isOpened}
        isLoading={isLoading}
        action={
          <DefaultButton
            containerClass={classes.sendNotification}
            color="secondary"
            disabled={!this.state.message}
            onClick={this.handleSubmit}
            size="small"
            variant="contained"
          >
            Send
          </DefaultButton>
        }
      >
        <Typography className={classes.notifyModalHelper}>
          Send an email and Educator Passport app notification to registered
          Educators!
        </Typography>
        <WaveTextArea
          label="Message"
          maxLength={1000}
          onChange={this.handleMessageChange}
          rows="4"
          value={this.state.message}
        />
      </DefaultModal>
    );
  }
}

const StyledNotifyAttendeesModal = withStyles(NotifyAttendeesModal, notifyModalStyles, {
  withTheme: true
});

export { StyledNotifyAttendeesModal as NotifyAttendeesModal };
